import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  CircularProgress,
  Grid2,
  Modal,
  Typography,
} from "@mui/material";
import defaultProfile from "../../assets/images/defaultProfile2.webp";
import { getAgeFromTimestamp, getTeamProfilePic } from "../../uttils/common";
import { icons } from "../../assets/icons/icons";
import { colors } from "../../values/colors";
import { useGetAllRolesQuery } from "../../services/auctionAPI";

const SoldConfirmModal = ({
  open,
  onClose,
  onConfirm,
  player,
  team,
  playerNumber,
  isLoading,
}) => {
  const { data: rolesData } = useGetAllRolesQuery();
  const roles = rolesData?.data || [];

  // ⭐ Find role name from roleId
  const roleName = roles?.find(
    (r) => r?._id === player?.playerId?.roleId
  )?.name;

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          //   width: 400,
          p: 3,
          borderRadius: "16px",
          boxShadow: "0px 4px 25px rgba(0,0,0,0.15)",
          textAlign: "center",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Are you sure you want to sell this player to?
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <Box
            sx={{
              boxShadow: "0px 18.46px 18.46px 0px rgba(126, 126, 126, 0.11)",
              p: 2,
              borderRadius: ".5rem",
              width: "16rem",
              height: "25rem",
            }}
          >
            <CardMedia
              component="img"
              image={
                player?.playerId?.profilePic
                  ? player?.playerId?.profilePic
                  : defaultProfile
              }
              alt={player?.name}
              sx={{
                borderRadius: "12px",
                width: "100%",
                height: "13rem",
                mb: 2,
              }}
            />
            <Box sx={{ p: 0 }}>
              <Typography
                variant="body1"
                sx={{ mb: 0.5, fontWeight: "600", fontSize: "1.2rem" }}
              >
                Player Id: {playerNumber}
              </Typography>
              
                <Grid2 item>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "600", fontSize: "1.2rem" }}
                  >
                    {player?.playerId?.name}&nbsp;
                  </Typography>
                </Grid2>
                <Grid2 item>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "600", fontSize: "1.2rem" }}
                  >
                    {roleName}
                  </Typography>
                </Grid2>
              
              <Typography
                variant="body1"
                sx={{ fontWeight: "600", fontSize: "1.2rem" }}
              >
                {player?.dob && getAgeFromTimestamp(player?.dob)}
              </Typography>
            </Box>
          </Box>
          <Box>
            <img src={icons.rightarrow} alt="arrow" />
          </Box>
          <Box
            sx={{
              boxShadow: "0px 18.46px 18.46px 0px rgba(126, 126, 126, 0.11)",
              p: 2,
              borderRadius: ".5rem",
              width: "16rem",
              height: "25rem",
            }}
          >
            <CardMedia
              component="img"
              image={getTeamProfilePic(team?.[0]?.teamLogo)}
              alt={player?.name}
              sx={{
                borderRadius: "12px",
                width: "100%",
                height: "13rem",
                mb: 2,
              }}
            />
            <Box sx={{ p: 0 }}>
              <Typography
                variant="body1"
                sx={{ mb: 0.5, fontWeight: "600", fontSize: "1.7rem" }}
              >
                {team?.[0]?.teamName}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "center",
            gap: "1.5rem",
          }}
        >
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              backgroundColor: "#1E1E1E",
              color: "#fff",
              textTransform: "none",
              borderRadius: "999px",
              py: ".9rem",
              fontSize: "1rem",
              width: "10rem",
              "&:hover": { backgroundColor: "#000" },
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{
              background: colors.linearGradent,
              color: "#fff",
              textTransform: "none",
              borderRadius: "999px",
              width: "10rem",
            }}
          >
            {isLoading ? (
              <CircularProgress
                size={28}
                sx={{
                  color: "#fff",
                }}
              />
            ) : (
              "Yes"
            )}
          </Button>
        </Box>
      </Card>
    </Modal>
  );
};

export default SoldConfirmModal;
